import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getColor } from '@/helpers/utils';
import { useState } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { Spinner } from 'react-bootstrap';
import { AiOutlineZoomIn } from 'react-icons/ai';
import { MdCheck, MdContentCopy, MdOutlineOpenInNew } from 'react-icons/md';
import { useLocation, useSearchParams } from 'react-router-dom';
import {
  generateQueryStringByKeys,
  getQueryStringKeys
} from '@/utils/queryString';
import { errorMessage } from '@/utils/toast';
// نمایش url ها در جدول
type URLRendererFactoryValue = string | number | undefined;
type URLRendererValue =
  | URLRendererFactoryValue
  | (() => URLRendererFactoryValue);

type URLRendererProps = {
  url?: string | null;
  hideLockIcon?: boolean;
  job_page?: string | number | null;
  status_code?: string | number | null;
  details?: URLRendererValue;
  type?: string;
  activeTab?: URLRendererValue;
  addition?: ReactNode;
  style?: CSSProperties;
  modifyOpeners?: string | null;
  enableCopyAndRedirect?: boolean;
  queries?: string[];
  className?: string;
  gapOfbuttons?: string;
  icon?: ReactNode;
};

const URLRenderer = ({
  url,
  hideLockIcon = false,
  job_page,
  status_code,
  details = '',
  type = '',
  activeTab = '',
  addition,
  style = {},
  modifyOpeners,
  enableCopyAndRedirect = true,
  queries = [],
  className = '',
  gapOfbuttons = 'ms-2',
  icon = ''
}: URLRendererProps) => {
  const detailsValue = typeof details === 'function' ? details() : details;
  const activeTabValue =
    typeof activeTab === 'function' ? activeTab() : activeTab;
  let searchParamUrl: string | undefined;
  try {
    searchParamUrl = decodeURIComponent(url ?? '');
  } catch (error) {
    console.log('Error in decode URI URLRenderer.');
  }
  try {
    url = decodeURIComponent(url ?? '');
  } catch (error) {
    console.log('Error in decode URI URLRenderer.');
  }

  const [copied, setCopied] = useState(false);
  const [openerClicked, setopenerClicked] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const loation = useLocation();
  const urlParams = new URLSearchParams(loation.search);

  // نحوه نمایش لینک https یا https
  const urlFormater = () => {
    if (url?.startsWith('https://'))
      return (
        <>
          {!hideLockIcon && (
            <FontAwesomeIcon
              size="sm"
              icon={'lock'}
              title="https"
              color={getColor('success')}
              className="ms-1"
            />
          )}
          {url.replace('https://', '')}
        </>
      );
    else if (url?.startsWith('http://'))
      return (
        <>
          {!hideLockIcon && (
            <FontAwesomeIcon
              size="sm"
              icon={'lock-open'}
              title="http"
              color={getColor('danger')}
              className="ms-1"
            />
          )}
          {url.replace('http://', '')}
        </>
      );
    else {
      return <>{url}</>;
    }
  };

  return (
    <span
      className={`text-end w-100 text-900 ${className}`}
      style={{ direction: 'ltr', ...style }}
    >
      {url === 'https://' && (
        <span className="d-flex text-1100 gap-1 align-items-baseline">
          <FontAwesomeIcon
            size="sm"
            icon={'lock'}
            title="https"
            color={getColor('success')}
            className="ms-1"
          />
          {url}
        </span>
      )}
      {url === 'http://' && (
        <span className="d-flex text-1100 gap-1 align-items-baseline">
          <FontAwesomeIcon
            size="sm"
            icon={'lock-open'}
            title="http"
            color={getColor('danger')}
            className="ms-1"
          />
          {url}
        </span>
      )}
      {url && url !== 'null' && url !== 'http://' && url !== 'https://' && (
        <>
          <span
            className={
              enableCopyAndRedirect
                ? 'd-flex text-1100 gap-1 align-items-baseline'
                : 'me-2'
            }
          >
            {icon && icon} {urlFormater()} {addition}
          </span>
          {/* دکمه های کپی ، بازکردن پیوند و یا جزییات نشانی */}
          {enableCopyAndRedirect && (
            <div
              id="UrlMenu"
              className={`position-absolute  pe-3 ${gapOfbuttons} opacity-100 top-50 start-0 d-flex gap-1 align-items-center justify-content-center`}
              style={{
                zIndex: 6000,
                transform: 'translate(0,-65%)',
                height: 30
              }}
            >
              {copied ? (
                <MdCheck size={18} />
              ) : (
                <MdContentCopy
                  title="کپی پیوند"
                  onClick={() => {
                    const openerUrl = modifyOpeners || url || '';
                    navigator.clipboard
                      .writeText(openerUrl)
                      .then(() => {
                        setCopied(true);
                        setTimeout(() => {
                          setCopied(false);
                        }, 3000);
                      });
                  }}
                  className="cursor-pointer little-icon"
                  style={{ paddingLeft: '3px' }}
                  size={18}
                />
              )}

              <MdOutlineOpenInNew
                title="بازکردن پیوند"
                onClick={() => {
                  try {
                    window.open(
                      decodeURI(modifyOpeners || url || ''),
                      '_blank'
                    );
                  } catch (error) {
                    // Handle the error here
                    errorMessage('.پیوند قابل بازکردن نمی‌باشد');
                    console.error('خطا در بازکردن پیوند:', error);
                  }
                }}
                className="cursor-pointer little-icon"
                style={{ paddingLeft: '3px' }}
                size={18}
              />
              {openerClicked ? (
                <Spinner
                  animation="border"
                  style={{
                    width: '18px',
                    marginBottom: '-3px',
                    paddingLeft: '3px',
                    height: '18px'
                  }}
                />
              ) : (
                <>
                  {activeTab && (
                    <AiOutlineZoomIn
                      title="جزئیات نشانی"
                      onClick={() => {
                        const filterKeys = getQueryStringKeys(
                          searchParams.toString(),
                          []
                        );
                        setSearchParams(
                          Object.assign(
                            {},
                            generateQueryStringByKeys(urlParams, queries),
                            generateQueryStringByKeys(urlParams, filterKeys),
                            {
                              details:
                                detailsValue === undefined
                                  ? ''
                                  : String(detailsValue),
                              type,
                              activeTab:
                                activeTabValue === undefined
                                  ? ''
                                  : String(activeTabValue),
                              page_url: searchParamUrl ?? '',
                              job_page: job_page == null ? '' : String(job_page),
                              status_code:
                                status_code == null ? '' : String(status_code)
                            }
                          )
                        );
                        setopenerClicked(true);
                        setTimeout(() => {
                          setopenerClicked(false);
                        }, 3000);
                      }}
                      className="cursor-pointer little-icon"
                      style={{ paddingLeft: '3px' }}
                      size={18}
                    />
                  )}
                </>
              )}
            </div>
          )}
          <style>{`
              #UrlMenu {
                display:none !important;
              }
              .ag-row-hover.ag-row-level-0 #UrlMenu {
                display: initial !important;
                background-color: var(--ag-column-hover-color)!important;
              }
              .ag-row-selected.ag-row-level-0 #UrlMenu {
                display: none !important;
                background-color:var(--ag-selected-row-background-color);
              }
              //TODO ag-cell-range-selected ag-cell-range-selected-1 ag-cell-range-top ag-cell-range-right
              // .ag-cell-range-selected-1:not(.ag-cell-focus), .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing) .ag-row-hover #UrlMenu{
              //   display: initial !important;
              //   background-color: var(--ag-range-selection-background-color) !important;
              //  }
              // .ag-row-hover.ag-row-selected #UrlMenu{
              //   display: initial !important;
              //   background-color: var(--ag-row-hover-color);
              //   background-image: linear-gradient(var(--ag-selected-row-background-color), var(--ag-selected-row-background-color));        
              // }
    `}</style>
        </>
      )}
    </span>
  );
};

export default URLRenderer;

// .ag-cell-range-selected:not(.ag-cell-focus),
// .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing) {
//   background-color: var(--ag-range-selection-background-color);
// }
// .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,
// .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart {
//   background-color: var(--ag-range-selection-chart-background-color) !important;
// }
// .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,
// .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category {
//   background-color: var(--ag-range-selection-chart-category-background-color) !important;
// }

// .ag-cell-range-selected-1:not(.ag-cell-focus),
// .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing) {
//   background-color: var(--ag-range-selection-background-color);
// }

// .ag-cell-range-selected-2:not(.ag-cell-focus),
// .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2 {
//   background-color: var(--ag-range-selection-background-color-2);
// }

// .ag-cell-range-selected-3:not(.ag-cell-focus),
// .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3 {
//   background-color: var(--ag-range-selection-background-color-3);
// }

// .ag-cell-range-selected-4:not(.ag-cell-focus),
// .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4 {
//   background-color: var(--ag-range-selection-background-color-4);
// }

// .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top {
//   border-top-color: var(--ag-range-selection-border-color);
//   border-top-style: var(--ag-range-selection-border-style);
// }
// .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right {
//   border-right-color: var(--ag-range-selection-border-color);
//   border-right-style: var(--ag-range-selection-border-style);
// }
// .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom {
//   border-bottom-color: var(--ag-range-selection-border-color);
//   border-bottom-style: var(--ag-range-selection-border-style);
// }
// .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left {
//   border-left-color: var(--ag-range-selection-border-color);
//   border-left-style: var(--ag-range-selection-border-style);
// }
